import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Country, State }  from 'country-state-city';
import Button from "../../../../../../../../../../components/button";
import Icon from "../../../../../../../../../../components/icon";
import Input from '../../../../../../../../../../components/input';
import Select from '../../../../../../../../../../components/select';
import './index.css';

function NewContactPostalAddressRow (props) {

	const [stateDisplay, setStateDisplay] = useState('');
	const { t } = useTranslation();


	const { postalAddress } = props;

	useEffect(() => {
		setStateDisplay(postalAddress.countryCode);
	}, [postalAddress.countryCode]);

	const handleChange = (e) => {
		setStateDisplay(e.currentTarget.value);
	};

    return (
        <div className={`new-contact-postal-address-row d-flex py-2`}>
            <div className="col-1 d-flex align-items-start justify-content-center">
                {
                    props.index === 0
                    ?
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <path fill="none" d="M0 0h24v24H0V0z"/>
                            <path
                                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
                            <circle cx="12" cy="9" r="2.5"/>
                        </svg>
                    :
                        ''
                }
            </div>
	        <div className="col-md-10 form-body">
		        <div className="row mb-3">
			        <div className="col-4">
				        <input
					        type="text"
					        className="form-control"
					        id={`street-${props.index}`}
					        defaultValue={props.postalAddress.street}
					        autoComplete={'' + Math.random()}
					        placeholder={t("textStreet")}/>
			        </div>
			        <div className="col-4">
				        <input
					        type="text"
					        className="form-control"
					        id={`neighborhood-${props.index}`}
					        defaultValue={props.postalAddress.neighborhood}
					        autoComplete={'' + Math.random()}
					        placeholder={"Neighborhood"}/>
			        </div>
			        <div className="col-4">
				        <input
					        type="text"
					        className="form-control"
					        id={`postCode-${props.index}`}
					        defaultValue={props.postalAddress.postCode}
					        placeholder={t("textPostCode")}
				        />
			        </div>
		        </div>
		        <div className="row mb-3">
			        <div className="col-6">
				        <input
					        type="text" className="form-control"
					        id={`city-${props.index}`}
					        defaultValue={props.postalAddress.city}
					        placeholder={t("textCity")}
				        />
			        </div>
			        <div className="col-6">
				        <Input
					        id={`postal-address-label-${props.index}`}
					        list={`postal-address-label-list-${props.index}`}
					        name="postal-address-label"
					        defaultValue={props.postalAddress.label}
						      	placeholder={t("fieldLabelPlaceholder")}
				        />
				        <datalist id={`postal-address-label-list-${props.index}`}>
					        <option value={t("fieldLabelWork")}/>
					        <option value={t("fieldLabelHome")}/>
					        <option value={t("fieldLabelOther")}/>
				        </datalist>
			        </div>
		        </div>
		        <div className="row">
			        <div className="col-6">
				        <Select onChange={handleChange}>
					        <option value="">-- {t("textSelectCountry")}--</option>
					        {
						        Country.getAllCountries().map(country => (
							        <option key={country.isoCode} value={country.isoCode}>{country.name}</option>
						        ))
					        }
				        </Select>
			        </div>
			        <div className="col-6">
				        <Select>
					        <option value="">-- {t("textSelectState")} --</option>
					        {
						        State.getStatesOfCountry(stateDisplay).map( state => (
							        <option key={state.isoCode} value={state.name}>{state.name}</option>
						        ))
					        }
				        </Select>
			        </div>
		        </div>
	        </div>


            <div className="col-1 d-flex align-items-center justify-content-center">
                {
                    props.index === 0
                    ?
                        <Button className="btn-link p-0 add" onClick={props.newPostalAddressRow}>
                            <Icon name="plus-circle"/>
                        </Button>
                    :
                        ''
                }
                {
                    props.index > 0
                    ?
                        <Button data-index={props.index} className="btn-link delete" onClick={props.deletePostalAddressRow}>
                            <Icon name="times"/>
                        </Button>
                    :
                        null
                }
            </div>
        </div>
    );
}

export default NewContactPostalAddressRow;
